import type { MultipleOpportunity, SingleOpportunity } from '@ps/isp-web-services-types';
import { notEmpty } from '@ps/web-core-utils';

import type { BetSlipState } from '../types';

import { getIsAvailableOpportunity } from './getIsOpportunity';

export const generateAcceptedOdds = (
  acceptedOdds: BetSlipState['acceptedOdds'],
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): BetSlipState['acceptedOdds'] => ({
  ...acceptedOdds,
  ...opportunities.reduce<BetSlipState['acceptedOdds']>((acc, next) => {
    const acceptedOpportunityOdds = acceptedOdds[next.id];

    if (!notEmpty(acceptedOpportunityOdds)) {
      acc[next.id] = getIsAvailableOpportunity(next) ? next.winRunnerOdds : undefined;
    }

    return acc;
  }, {})
});
